import type { ComponentType } from "react";
import { Helmet } from "react-helmet-async";

import { siteConfig } from "../config/site";
import PrivacyDoc, { frontmatter as privacyFrontmatter } from "../content/legal/privacy.md";
import TermsDoc, { frontmatter as termsFrontmatter } from "../content/legal/terms.md";
import { childRoutePath, siteRoutes } from "../routes";

type LegalFrontmatter = {
  title?: string;
  effectiveDate?: string;
  lastUpdated?: string;
};

type LegalRoute = {
  path: string;
  doc: ComponentType;
  frontmatter: LegalFrontmatter;
};

export const legalRoutes: LegalRoute[] = [
  {
    path: childRoutePath(siteRoutes.privacy),
    doc: PrivacyDoc,
    frontmatter: privacyFrontmatter as LegalFrontmatter,
  },
  {
    path: childRoutePath(siteRoutes.terms),
    doc: TermsDoc,
    frontmatter: termsFrontmatter as LegalFrontmatter,
  },
];

export function LegalPage(props: LegalRoute) {
  const title = props.frontmatter.title ?? "Legal";
  const effectiveDate = props.frontmatter.effectiveDate;
  const lastUpdated = props.frontmatter.lastUpdated;
  const Doc = props.doc;

  return (
    <>
      <Helmet>
        <title>
          {title} · {siteConfig.name}
        </title>
      </Helmet>

      <section className="space-y-10">
        <header className="space-y-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
            legal
          </p>
          <h1 className="font-display text-4xl tracking-tight sm:text-5xl">{title}</h1>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-muted-foreground">
            {effectiveDate ? (
              <div className="flex items-center gap-2">
                <span className="font-mono">effective</span>
                <span className="font-mono">{effectiveDate}</span>
              </div>
            ) : null}
            {lastUpdated ? (
              <div className="flex items-center gap-2">
                <span className="font-mono">updated</span>
                <span className="font-mono">{lastUpdated}</span>
              </div>
            ) : null}
          </div>
        </header>

        <article className="prose prose-neutral max-w-none">
          <Doc />
        </article>
      </section>
    </>
  );
}
